import { apiRequestBase } from './client';
import { env } from '../config/env';

export const authApi = {
  checkPermission: (permissionIdentifier: string, menuIdentifier: string) =>
    apiRequestBase<any>(env.authApiBase, '/RoleModulePermission/CheckAuthorizationStatus', {
      method: 'POST',
      body: { permissionIdentifier, menuIdentifier, isFromGuard: false },
    }),
};
